import { Typography, Box, Divider, Paper, Grid, useMediaQuery } from "@mui/material";
import SinapThemev2 from "../styles/SinapThemev2";
import NoticiasProcess from "./NoticiasProcess";

export default function NoticiasHome({ notices, loading }) {
    const matches = useMediaQuery('(min-width:1185px)');

    return (
        <Grid container direction="column" justifyContent="space-between">
            <Typography fontSize={matches ? "28px" : "30px"} my="40px" mx="10px">
                Noticias Institucionales
            </Typography>
            <Grid item xs={12} mx={matches ? "50px" : "0px"}>
                <Grid container direction={matches ? "row" : "column"}
                    justifyContent="space-between"
                    alignItems={matches ? "stretch" : "center"}
                    spacing={5}>
                    <Grid item xs={matches ? 4 : 12}>
                        <br />
                        <Typography variant="h5" color={SinapThemev2.palette.primary.main}
                            style={{ textAlign: 'center', alignContent: 'center' }}>
                            <b>Noticias Grado</b>
                        </Typography>
                        <br />
                        <Box sx={{ padding: '20px' }}>
                            <NoticiasProcess notices={notices.GR} loading={loading} />
                        </Box>
                    </Grid>
                    <Grid item xs={matches ? 4 : 12}>
                        <br />
                        <Typography variant="h5" color={SinapThemev2.palette.primary.main}
                            style={{ textAlign: 'center', alignContent: 'center' }}>
                            <b>Noticias Aspirantes</b>
                        </Typography>
                        <br />
                        <Box sx={{ padding: '20px' }}>
                            <NoticiasProcess notices={notices.PR} loading={loading} />
                        </Box>
                    </Grid>
                    <Grid item xs={matches ? 4 : 12}>
                        <br />
                        <Typography variant="h5" color={SinapThemev2.palette.primary.main}
                            style={{ textAlign: 'center', alignContent: 'center' }}>
                            <b>Noticias Pos-Grado</b>
                        </Typography>
                        <br />
                        <Box sx={{ padding: '20px' }}>
                            <NoticiasProcess notices={notices.PO} loading={loading} />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
